module.exports = __webpack_public_path__ + "static/img/empty-member.5767005e.png";